<template>
  <!--#ifdef H5 -->
  <svg
    :style="{ color: color, width: width, height: height }"
    :class="svgClass"
    aria-hidden="true"
  >
    <use :xlink:href="'#' + name" />
  </svg>
  <!--#endif -->
</template>
<script>
export default {
  name: 'SymbolIcon',
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgClass() {
      return 'cube-icon-symbol' + ` ${this.className}` || ''
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.cube-icon-symbol {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.font-size-100 .cube-icon-symbol {
  width: 0.16rem;
  height: 0.16rem;
}
</style>
